import { mapState } from 'vuex'
import copyTextMixin from '@/components/mixins/copy-text-mixin'

export default {
  /**
   * Компонент используется для
   * истории заказа, вкладка "Все изменения"
   */
  name: 'BeforeAfterEvent',
  /**   * 
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
  mixins: [copyTextMixin],
  props: {
    event: {
      type: Object,
      required: true
    },
    state: {
      type: String, // before | after
      default: 'after'
    },
  },
  computed: {
    ...mapState({
      orderStatuses: state => state.sharedData.orderStatuses
    })
  },
  methods: {
    getRoutTaskText(routeTaskId) {
      return  `м ${routeTaskId}`
    },
    selectRouteTask(event, routeTaskId) {
      if (this.isShiftPress) {
        this.onCopyText(event, this.getRoutTaskText(routeTaskId))
        return
      }
      this.$emit('set-route-task', routeTaskId)
    },
  }
}